export const PROJECT_WITH_REGIONS = 'projectWithRegions';

export const PROJECT_WITH_REGIONS_ACTIONS_NAME = {
  searchProjects: `${PROJECT_WITH_REGIONS}/searchProjects`,
  getProjectsWithForeignParticipationDatesCount: `${PROJECT_WITH_REGIONS}/getProjectsWithForeignParticipationDatesCount`,
  setIsLoadingCount: `${PROJECT_WITH_REGIONS}/setIsLoadingCount`,
} as const;

export const PROJECT_WITH_REGIONS_MUTATIONS_NAME = {
  setListOfProjects: `${PROJECT_WITH_REGIONS}/setListOfProjects`,
  setProjectsWithForeignParticipationDatesCount: `${PROJECT_WITH_REGIONS}/setProjectsWithForeignParticipationDatesCount`,
  setIsLoadingCount: `${PROJECT_WITH_REGIONS}/setIsLoadingCount`,
} as const;

export const PROJECT_WITH_REGIONS_GETTERS_NAME = {
  getListOfProjects: `${PROJECT_WITH_REGIONS}/getListOfProjects`,
  getProjectsWithForeignParticipationDatesCount: `${PROJECT_WITH_REGIONS}/getProjectsWithForeignParticipationDatesCount`,
  getIsLoadingCount: `${PROJECT_WITH_REGIONS}/getIsLoadingCount`,
} as const;
